
var onAirPreview = {
    Image: "#imgOnAirPreview",
    ImageBase64: "#hfOnAirImageContent",
    DropElementId: 'onAirUploader',
    BrowseButtonId: 'onAirSelectFiles'
},
    offAirPreview = {
        Image: "#imgOffAirPreview",
        ImageBase64: "#hfOffAirImageContent",
        DropElementId: 'offAirUploader',
        BrowseButtonId: 'offAirSelectFiles'
    },
    streamId = jQuery("#hiddenStreamId").val(),
    recordingAdminUrl = jQuery("#HapiUrl").val() + "/v1/streams/" + streamId + "/recording/",
    streamingAdminUrl = jQuery("#HapiUrl").val() + "/v1/streams/" + streamId + "/streaming/",
    startRecordingButton = "#btnStartRecording",
    stopRecordingButton = "#btnStopRecording",
    startRtspStreamAndRecordingButton = '#btnStartStreamAndRecordRtsp',
    stopRtspStreamAndRecordingButton = '#btnStopStreamAndRecordRtsp',
    startRtspStreamButton = '#btnStartStreamRtsp',
    stopRtspStreamButton = '#btnStopStreamRtsp',
    startRtspRecordingButton = '#btnStartRecordingRtsp',
    stopRtspRecordingButton = '#btnStopRecordingRtsp',
    status = ".streamState",
    processingSpinnerId = "#processingSpinner",
    recordingActionClass = ".btnRecAction",
    encodingMethodId = 'ddlEncodingMethod',
    //Start/Stop Recording
    handleRtmpRecordingAction = function (startRecording) {
        try {
            var processingSpinner = jQuery(processingSpinnerId);
            jQuery.ajax({
                url: recordingAdminUrl + (startRecording ? "start" : "stop"),
                data: { streamId: streamId },
                contentType: 'json',
                beforeSend: function () {
                    jQuery(recordingActionClass).addClass('hidden');
                    processingSpinner.css('display', 'inline-block');
                },
                success: function (response) {
                    processingSpinner.hide();
                    var actionResult = jQuery.parseJSON(response);
                    if (actionResult.success) {
                        if (startRecording) {
                            jQuery(status).removeClass('text-green3').addClass('text-red3').html(actionResult.status);
                            jQuery(stopRecordingButton).removeClass('hidden');
                        } else {
                            jQuery(status).removeClass('text-red3').addClass('text-green3').html(actionResult.status);
                            jQuery(startRecordingButton).removeClass('hidden');
                        }
                    } else {
                        processingSpinner.css('display', 'none');
                        jQuery(status).removeClass('text-green3').addClass('text-red3').html(actionResult.message);
                        if (startRecording) {
                            jQuery(startRecordingButton).removeClass('hidden');
                        } else {
                            jQuery(stopRecordingButton).removeClass('hidden');
                        }
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(thrownError);
                    processingSpinner.css('display', 'none');
                    if (startRecording) {
                        jQuery(startRecordingButton).removeClass('hidden');
                    } else {
                        jQuery(stopRecordingButton).removeClass('hidden');
                    }
                }
            });
        } catch (e) { }

    },
    handleRtspCaptureAction = function (startRecording) {
        try {
            var processingSpinner = jQuery(processingSpinnerId);
            jQuery.ajax({
                url: (startRecording ? streamingAdminUrl + "pull/start?recordStream=true" : recordingAdminUrl + "pull/stop?stopStream=true"),
                data: { streamId: streamId },
                contentType: 'json',
                beforeSend: function () {
                    disableEncodingMethod();
                    jQuery(recordingActionClass).addClass('hidden');
                    processingSpinner.css('display', 'inline-block');
                },
                success: function (response) {
                    processingSpinner.css('display', 'none');
                    var actionResult = jQuery.parseJSON(response);
                    if (actionResult.success) {
                        if (startRecording) {
                            jQuery(status).removeClass('text-green3').addClass('text-red3').html(actionResult.status);
                            jQuery(stopRtspStreamAndRecordingButton).removeClass('hidden');
                        } else {
                            enableEncodingMethod();
                            jQuery(status).removeClass('text-red3').addClass('text-green3').html(actionResult.status);
                            jQuery(startRtspStreamAndRecordingButton).removeClass('hidden');
                        }
                    } else {
                        jQuery(status).removeClass('text-green3').addClass('text-red3').html(actionResult.message);
                        if (startRecording) {
                            enableEncodingMethod();
                            jQuery(startRtspStreamAndRecordingButton).removeClass('hidden');
                        } else {
                            jQuery(stopRtspStreamAndRecordingButton).removeClass('hidden');
                        }
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(thrownError);
                    processingSpinner.css('display', 'none');
                    if (startRecording) {
                        enableEncodingMethod();
                        jQuery(startRtspStreamAndRecordingButton).removeClass('hidden');
                    } else {
                        jQuery(stopRtspStreamAndRecordingButton).removeClass('hidden');
                    }
                }
            });
        } catch (e) { }

    },
    handleRtspLiveAction = function (id) {
        try {

            var url = '';
            var isStartAction = false;
            var isStreamingAction = false;
            if (id === 'btnStartStreamRtsp') {
                isStartAction = true;
                isStreamingAction = true;
                url = streamingAdminUrl + 'pull/start';
            } else if (id === 'btnStopStreamRtsp') {
                isStreamingAction = true;
                url = streamingAdminUrl + 'pull/stop';
            } else if (id === 'btnStartRecordingRtsp') {
                isStartAction = true;
                url = recordingAdminUrl + 'pull/start';
            } else if (id === 'btnStopRecordingRtsp') {
                url = recordingAdminUrl + 'pull/stop';
            }

            var processingSpinner = jQuery(processingSpinnerId);
            jQuery.ajax({
                url: url,
                data: { streamId: streamId },
                contentType: 'json',
                beforeSend: function () {
                    disableEncodingMethod();
                    jQuery(recordingActionClass).addClass('hidden');
                    processingSpinner.css('display', 'inline-block');
                },
                success: function (response) {
                    processingSpinner.css('display', 'none');
                    var actionResult = jQuery.parseJSON(response);
                    if (actionResult.success) {
                        if (isStreamingAction) {
                            jQuery(status).removeClass('text-red3').addClass('text-green3').html(actionResult.status);
                            if (isStartAction) {
                                jQuery(stopRtspStreamButton).removeClass('hidden');
                                jQuery(startRtspRecordingButton).removeClass('hidden');
                            } else {
                                jQuery(startRtspStreamButton).removeClass('hidden');
                                enableEncodingMethod();
                            }
                        } else {
                            if (isStartAction) {
                                jQuery(status).removeClass('text-green3').addClass('text-red3').html(actionResult.status);
                                jQuery(stopRtspStreamButton).removeClass('hidden');
                                jQuery(stopRtspRecordingButton).removeClass('hidden');
                            } else {
                                jQuery(status).removeClass('text-red3').addClass('text-green3').html(actionResult.status);
                                jQuery(stopRtspStreamButton).removeClass('hidden');
                                jQuery(startRtspRecordingButton).removeClass('hidden');
                            }
                        }
                    } else {
                        jQuery(status).removeClass('text-green3').addClass('text-red3').html(actionResult.message);
                        if (isStreamingAction) {
                            if (jQuery(isStartAction)) {
                                enableEncodingMethod();
                                jQuery(startRtspStreamButton).removeClass('hidden');
                            } else {
                                jQuery(stopRtspStreamButton).removeClass('hidden');
                            }
                        } else {
                            if (jQuery(isStartAction)) {
                                jQuery(startRtspRecordingButton).removeClass('hidden');
                            } else {
                                jQuery(stopRtspRecordingButton).removeClass('hidden');
                            }
                        }
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(thrownError);
                    enableEncodingMethod();
                    processingSpinner.css('display', 'none');
                    if (isStreamingAction) {
                        if (jQuery(isStartAction)) {
                            enableEncodingMethod();
                            jQuery(startRtspStreamButton).removeClass('hidden');
                        } else {
                            jQuery(stopRtspStreamButton).removeClass('hidden');
                        }
                    } else {
                        if (jQuery(isStartAction)) {
                            enableEncodingMethod();
                            jQuery(startRtspRecordingButton).removeClass('hidden');
                        } else {
                            jQuery(stopRtspRecordingButton).removeClass('hidden');
                        }
                    }
                }
            });
        } catch (e) { }

    },
    disableEncodingMethod = function () {
        jQuery('#' + encodingMethodId).attr('disabled', 'disabled');
        jQuery('button[data-id="' + encodingMethodId + '"]').addClass('disabled');
    },
    enableEncodingMethod = function() {
        jQuery('#' + encodingMethodId).removeAttr('disabled');
        jQuery('button[data-id="' + encodingMethodId + '"]').removeClass('disabled');
    },
    documentReady = function () {
        var contentTabs = jQuery(".tabContent");
        var headerTabs = jQuery(".tabHeader").on("click", function () {
            var newActiveContentTab = this.id.replace('Link', 'Content');
            jQuery(contentTabs).hide();
            jQuery(headerTabs).removeClass("mediaButtonSelected");
            jQuery("." + newActiveContentTab).show();
            jQuery(this).addClass("mediaButtonSelected");
        });

        createImageUploader(onAirPreview);
        createImageUploader(offAirPreview);

        tableConvertFromUtcToLocalDateTime();

        var streamStatus = jQuery(status).text();
        if (streamStatus === 'Streaming' || streamStatus === 'Recording') {
            disableEncodingMethod();
        } else {
            enableEncodingMethod();
        }
    };

function createImageUploader(settings) {
    // Instantiate the Plupload uploader.
    var uploader = new plupload.Uploader({

        // Try to load the HTML5 engine and then, if that's
        // not supported, the Flash fallback engine.
        runtimes: "html5,silverlight,flash",

        // The upload URL - for our demo, we'll just use a 
        // fake end-point (we're not actually uploading).
        url: "./post.json",

        // The ID of the drop-zone element.
        drop_element: settings.DropElementId,

        // To enable click-to-select-files, you can provide
        // a browse button. We can use the same one as the 
        // drop zone.
        browse_button: settings.BrowseButtonId,

        // For the Flash engine, we have to define the ID 
        // of the node into which Pluploader will inject the 
        // <OBJECT> tag for the flash movie.
        container: settings.DropElementId,

        // The URL for the SWF file for the Flash upload 
        // engine for browsers that don't support HTML5.
        flash_swf_url: "../../vendor/plupload/Moxie.swf",

        silverlight_xap_url: "../../vendor/plupload/Moxie.xap",

        // Needed for the Flash environment to work.
        urlstream_upload: true,

        multi_selection: false

    });

    uploader.bind("FilesAdded", function (uploader, files) {
        var file = files[0];

        // Create an instance of the mOxie Image object. This
        // utility object provides several means of reading in
        // and loading image data from various sources.
        // --
        // Wiki: https://github.com/moxiecode/moxie/wiki/Image
        var preloader = new moxie.image.Image();

        // Define the onload BEFORE you execute the load() 
        // command as load() does not execute async.
        preloader.onload = function () {

            var base64Content = preloader.getAsDataURL();
            jQuery(settings.ImageBase64).val(base64Content);

            // Now that the image is preloaded, grab the Base64
            // encoded data URL. This will show the image 
            // without making an Network request using the 
            // client-side file binary.
            jQuery(settings.Image).prop("src", base64Content);
        };

        // Calling the .getSource() on the file will return an
        // instance of mOxie.File, which is a unified file 
        // wrapper that can be used across the various runtimes.
        // --
        // Wiki: https://github.com/moxiecode/plupload/wiki/File
        preloader.load(file.getSource());
    });

    // Initialize the uploader (it is only after the 
    // initialization is complete that we will know which
    // runtime load: html5 vs. Flash).
    uploader.init();
}


jQuery(document).ready(documentReady);

var prm = Sys.WebForms.PageRequestManager.getInstance();
prm.add_endRequest(documentReady);
